/** @format */

export const BASE_URL = "https://solartec-backend.onrender.com";
